module.exports = __webpack_public_path__ + "img/hero-image.9ba25ac8.png";